export default {
  en: {
    title: "Create Facts",
    formTitle: "Facts",
    formDescription:
      "Facts are information that will allow you to identify something about a particular computer, network, or environment. Therefore, facts can be used to perform a variable assignment within the skills that will be part of planning an attack.",
    tabNew: "New Fact Source",
    tabCopy: "Copy a Fact Source",
    formNameLabel: "Facts Name",
    formNamePlaceholder:
      "Insert the name of the fact source you want to create",
    formSelectExistingLabel: "Select an existing Fact Source",
    formSelectExistingPlaceholder:
      "Select from the list an existing fact source to creat a copy",
    factsTitle: "Facts",
    factsSearchPlaceholder: "Find a trait or a value",
    factsButtonAdd: "Add Fact",
    factsOrderTitle: "Order",
    factsOriginTitle: "Origin",
    factsTraitTitle: "fact name",
    factsTraitPlaceholder: "Insert your trait",
    factsValueTitle: "value",
    factsValuePlaceholder: "Insert the value",
    factsScoreTitle: "score",
    factsScorePlaceholder: "0",
    factsEmptyListTitle: "This list is empty",
    factsEmptyListDescription:
      "Try add new items to this section and see it growing!",
    rulesTitle: "Rules",
    rulesSearchPlaceholder: "Find a trait or a value",
    rulesButtonAdd: "Add Rules",
    rulesButtonAddRule: "Add Rule",
    rulesOrderTitle: "Order",
    rulesMatchTitle: "Match",
    rulesMatchPlaceholder: "Insert your target",
    rulesTraitTitle: "Fact Name",
    rulesTraitPlaceholder: "Insert the value",
    rulesActionTitle: "Action",
    rulesActionDeny: "Deny",
    rulesActionAllow: "Allow",
    rulesEmptyListTitle: "This list is empty",
    rulesEmptyListDescription:
      "Try add new items to this section and see it growing!"
  },
  pt: {
    title: "Criar Facts",
    formTitle: "Facts",
    formDescription:
      "Fatos são informações que vão permitir identificar algo sobre um determinado computador, rede ou ambiente. Sendo assim, os fatos podem ser usados para realizar uma atribuição de variáveis dentro das habilidades que vão fazer parte do planejamento de um ataque.",
    tabNew: "Novo Fact Source",
    tabCopy: "Copiar um Fact Source",
    formNameLabel: "Nome do Facts",
    formNamePlaceholder: "Insira o nome do Fact Source que você deseja criar",
    formSelectExistingLabel: "Selecione um Fact Source existente",
    formSelectExistingPlaceholder:
      "Selecione da lista uma fonte de facts existente para criar uma cópia",
    factsTitle: "Facts",
    factsSearchPlaceholder: "Encontre uma característica ou um valor",
    factsButtonAdd: "Adicionar Fact",
    factsOrderTitle: "Ordem",
    factsOriginTitle: "Origem",
    factsTraitTitle: "nome do fact",
    factsTraitPlaceholder: "Insira seu trait",
    factsValueTitle: "valor",
    factsValuePlaceholder: "Insira o valor",
    factsScoreTitle: "pontuação",
    factsScorePlaceholder: "0",
    factsEmptyListTitle: "Esta lista está vazia",
    factsEmptyListDescription:
      "Tente adicionar novos itens a esta seção e veja-a crescer!",
    rulesTitle: "Rules",
    rulesSearchPlaceholder: "Encontre uma característica ou um valor",
    rulesButtonAdd: "Adicionar rule",
    rulesButtonAddRule: "Adicionar rule",
    rulesOrderTitle: "Ordem",
    rulesMatchTitle: "Combinar",
    rulesMatchPlaceholder: "Insira seu alvo",
    rulesTraitTitle: "Fact Name",
    rulesTraitPlaceholder: "Insira o valor",
    rulesActionTitle: "Ação",
    rulesActionDeny: "Negar",
    rulesActionAllow: "Permitir",
    rulesEmptyListTitle: "Esta lista está vazia",
    rulesEmptyListDescription:
      "Tente adicionar novos itens a esta seção e veja-a crescer!"
  },
  es: {
    title: "Crear Facts",
    formTitle: "Facts",
    formDescription:
      "Los facts son información que nos permite identificar algo sobre un ordenador, una red o un entorno concretos. Así, los facts pueden utilizarse para realizar una asignación de variables dentro de las habilidades que formarán parte de la planificación de un ataque.",
    tabNew: "Nuevo Fact Source",
    tabCopy: "Copiar un Fact Source",
    formNameLabel: "Nombre del fact",
    formNamePlaceholder: "Introduzca el nombre del Fact Source que desea crear",
    formSelectExistingLabel: "Seleccione un Fact Source existente",
    formSelectExistingPlaceholder:
      "Seleccione de la lista un Fact Source existente para crear una copia",
    factsTitle: "Facts",
    factsSearchPlaceholder: "Buscar un rasgo o un valor",
    factsButtonAdd: "Añadir un fact",
    factsOrderTitle: "Ordenar",
    factsOriginTitle: "Origen",
    factsTraitTitle: "nombre del Fact",
    factsTraitPlaceholder: "Inserte el trait",
    factsValueTitle: "valor",
    factsValuePlaceholder: "Inserte el valor",
    factsScoreTitle: "puntuación",
    factsScorePlaceholder: "0",
    factsEmptyListTitle: "Esta lista está vacía",
    factsEmptyListDescription:
      "¡Prueba a añadir nuevos artículos a esta sección y verás cómo crece!",
    rulesTitle: "Rules",
    rulesSearchPlaceholder: "Buscar un rasgo o un valor",
    rulesButtonAdd: "Añadir rule",
    rulesButtonAddRule: "Añadir rule",
    rulesOrderTitle: "Ordenar",
    rulesMatchTitle: "Coincidir con",
    rulesMatchPlaceholder: "Insertar el objetivo",
    rulesTraitTitle: "Hecho Rasgo",
    rulesTraitPlaceholder: "Inserte el valor",
    rulesActionTitle: "Acción",
    rulesActionDeny: "Denegar",
    rulesActionAllow: "Permitir",
    rulesEmptyListTitle: "Esta lista está vacía",
    rulesEmptyListDescription:
      "Pruebe a añadir nuevos elementos a esta sección y vea cómo crece."
  }
}
